import { medicalPatient, medicalWaste, officeAsset } from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import video from '@src/assets/images/solution/medicalPatient/video/rtlsVideo.mp4';

export default {
  desc: 'Công nghệ RTLS (Real-Time Location System - Hệ thống Định vị Thời gian Thực) đang tạo ra một cuộc cách mạng trong lĩnh vực chăm sóc sức khỏe hiện đại.',
  keywords:
    'Chăm sóc sức khỏe, theo dõi vị trí bệnh nhân, y tế thông minh, quản lý bệnh nhân, cham soc suc khoe, theo doi vi tri benh nhan, y te thong minh, quan ly benh nhan.',
  ogSite: 'RTLS trong lĩnh vực chăm sóc sức khỏe, có thể ứng dụng ngay',
  title: 'RTLS trong lĩnh vực chăm sóc sức khỏe, có thể ứng dụng ngay',
  ogUrl: 'https://orbro.io/vi/blog/rtlsHealthcare',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AK0iWDxCulBiV7gg1-xmVx62eta4ZCVo7bPai3vj9SN8ajL7XdyxO5_DwTc9AopMRDeHnIP1JRQ2aZs8YXRVegMIQ3XJAzQpGZPe7LsKZRYfG2TTKDwuITV4QU1esZgJZjvVrWFNk7tdYgfPUmag4WVUhkZm9kN2q9I3i-i7g39hykefddJoB-GGyLstWZXHZPGouEpHRHO-QSDUlk-5bfgHEXekgkw8khERLg03ek2jr9aZVu73vARqYrCfRjmXxpjdzbezfvYPPNqyHHEqz7ryYxrceLzeUag7SeXqCikIehVE0j-teEEB0twcIKzxDhQ926mrdivrYUsLL7Y73cfXmCIoQrwGuj_PWfjkx8---GZuGMDu2T0xCegVf_ixBlv-_DP0s4PYYug15P9K4RRQcy8wzkEIe8DXRrNFJxK06VwMVNt7IvsyGuGpztnYoPe9DTJVmh6DgvpkLVfrWOQROJ1mY3wPnWoRGDONddVgsZOg9IFlZ8XDLxhGIwf9_NUadZ72Sx1uku7HzFPuRiPUi_jEHwpZssTqer0dHqRrmEiUm7WIfEvksaY5tlVEdKCkt6rieJQk6XkQ7HLkH9Sft-gtWyMIbXXc-ezr8CI1QW-BSqTqW1u1RHOH_U8qsyeAMRsLziuReFdGt94MU0XLtJQjzm470ZW0Lyliq6-D-ACBxago-nL7bW3hByy9u4qrPcseGt9nDBtxez21nzH4j-kk-ikAGdM2lqgNjENR3W3iBBYZxCLEgg5FaWno-JnWFODzJ2EPDkL9YgV3eJXaSav9q-K9OGrHtGcdLoOoclYQdW6HGei2jvEzIvkJ7fOrE_BkaMDvwfP_mG1Wyfmazl4ZT-E3REcF7-H8fvG1Maj9lGE47sI9NaaLiuKxMUKkoOq7ATE-CsA56qjq0om1fHUHtL3k5dJaPw5dqFFc_I1pmQF2l6v32K36AQbL6URjYW2TRB5R_7PdZbxPltDvqVhv26deM1LrtslNSaQ1y8-v60TTOuJzwdCsBF2-a1Cgad2aG4c0gxmrniSlWna_ih_LT7LTZ78ekaoZK-QZbGYBhztrbJH8pG6OtYsABLu_EJbLwCZ8gemIFAL2str5ljuZjxGa8baorSqsutD4ZWG98EcUImwgTwfsXrg_fNe0Uyl2TmD1Jnr-cpdFvRHT9CtlmxJL0XV3CuWIB36kk7Sj451LQT1d3CUGDUYSob_cs6XtFvl8zo1L1iJO3CbaIL-X7qva6sYYjidWIQqBIwseA6TVk4ZZ4AB1lm8OMbmP-VwUqs4EahKtumqMiQXZoiUFyXyTKLz-soVKV_uVW4R9xcXy-pUYHMsYmRM2uDVc0eCkPkdr5NoidDFKrf03A4kPR2s3URy-bZdCORxE0KgtlQLx1eKtVi-Ku88pwYGe1IECBztZxTUfhisovrg-CZu2B3OOTHLZEZ3DTwH9ORlbfLRdJtLl21EkzHYHX485uwK40pglWChiD4G58da5pMDp2-tZtgrkAaEUw-gf3FoUya3HD4ywea6Tzxbua0wg9oJfPQYB4jUYPE8kQiPVTpz4TgFYI8iwU9sF8yUIRbW5c7kWjwIp=w2000-h1596',
  ogType: 'website',
  date: '2023-11-02',
  tag1: '#Chamsocsuckhoe',
  tag2: '#Theodoivitribenhnhan',
  tag3: '#Ytethongminh',
  tag4: '#Quanlybenhnhan',
  text: [
    {
      head: '',
      subHead: '',
      desc: 'Công nghệ RTLS (Real-Time Location System - Hệ thống Định vị Thời gian Thực) đang tạo ra một cuộc cách mạng trong lĩnh vực chăm sóc sức khỏe hiện đại. Công nghệ này đóng vai trò quan trọng trong việc nâng cao hiệu quả công việc tại các cơ sở y tế và tăng cường an toàn cho bệnh nhân bằng cách theo dõi vị trí của bệnh nhân theo thời gian thực, đồng thời quản lý hiệu quả các thiết bị y tế và nhân lực. Bài viết này sẽ làm rõ tầm quan trọng của công nghệ RTLS trong chăm sóc sức khỏe và những lợi ích khi có thể đưa vào sử dụng ngay.',
      dot: '',
    },
    {
      head: 'Nếu ứng dụng giải pháp này ngay bây giờ?',
      subHead: 'Tăng cường an toàn cho bệnh nhân',
      desc: 'RTLS là một phương tiện chủ chốt để tăng cường an toàn cho bệnh nhân thông qua việc theo dõi vị trí của họ. Khi nắm được vị trí của bệnh nhân theo thời gian thực, đội ngũ y tế có thể nhanh chóng đánh giá tình trạng của bệnh nhân và phản ứng tức thì khi có tình huống khẩn cấp xảy ra. Nhờ đó, có thể giảm thiểu các sai sót nghiêm trọng trong những trường hợp cấp cứu.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Cải thiện quản lý tài nguyên',
      desc: 'RTLS cho phép quản lý hiệu quả các thiết bị y tế và nhân viên y tế. Khi có thông tin vị trí theo thời gian thực của thiết bị y tế, việc tìm kiếm các thiết bị cần thiết trở nên nhanh chóng, đồng thời công tác bảo trì và thay thế cũng được thực hiện một cách hiệu quả. Hơn nữa, lịch trình của nhân viên y tế được tối ưu hóa, tránh xung đột lịch và giúp họ tập trung vào việc điều trị cho bệnh nhân.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Phòng chống lây nhiễm',
      desc: 'Thông qua RTLS, việc di chuyển của bệnh nhân trong bệnh viện có thể được quản lý một cách hiệu quả. Điều này giúp ngăn chặn sự lây lan của các bệnh truyền nhiễm và giảm thiểu tiếp xúc giữa các bệnh nhân trong bệnh viện. Nhờ đó, hạn chế được sự lan truyền của bệnh truyền nhiễm và bảo vệ an toàn cho cả bệnh nhân lẫn nhân viên y tế.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Quản lý tài chính',
      desc: 'Bằng việc áp dụng RTLS, các nguồn lực được sử dụng một cách hiệu quả, giúp cắt giảm chi phí. Ví dụ, có thể tránh được việc mua sắm thiết bị không cần thiết hoặc lãng phí vật tư tồn kho, đồng thời tối ưu hóa chi phí nhân lực. Điều này giúp cải thiện tình hình tài chính của bệnh viện và sử dụng ngân sách một cách hiệu quả.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Thông tin theo thời gian thực',
      desc: 'RTLS cung cấp thông tin vị trí theo thời gian thực, giúp đội ngũ y tế đưa ra quyết định nhanh chóng và hiệu quả hơn. Họ có thể phản ứng tức thì khi tình trạng của bệnh nhân thay đổi, nhờ đó cải thiện quy trình khám chữa bệnh và đạt được kết quả điều trị tốt nhất cho bệnh nhân.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Hiệu quả chi phí',
      desc: 'RTLS cung cấp các giải pháp hiệu quả về chi phí, tiết kiệm thời gian và nguồn lực, từ đó cải thiện tình hình tài chính của tổ chức. Có thể thu hồi vốn đầu tư nhanh chóng và về lâu dài, nâng cao hiệu quả chi phí.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Nâng cao sự hài lòng của bệnh nhân',
      desc: 'Thông qua việc theo dõi vị trí, bệnh nhân có thể nhận được sự chăm sóc cá nhân hóa hơn, đồng thời trải nghiệm mức độ hài lòng cao về sự an toàn và tiện nghi của bản thân. Điều này mang lại niềm tin và sự an tâm cho bệnh nhân và gia đình họ.',
      dot: '',
    },
    {
      head: 'Tóm tắt lại,',
      subHead: '',
      desc: 'Công nghệ RTLS trong chăm sóc sức khỏe đang mang lại những đổi mới to lớn cho lĩnh vực y tế hiện đại, và việc áp dụng ngay công nghệ này có thể giúp cải thiện an toàn cho bệnh nhân và nâng cao hiệu quả hoạt động. RTLS là một trong những công nghệ quan trọng, dễ dàng triển khai và mang lại kết quả nhanh chóng, do đó đem lại lợi ích cho cả các cơ sở y tế lẫn bệnh nhân. Thông qua đó, chúng ta có thể kỳ vọng rằng dịch vụ chăm sóc sức khỏe trong tương lai sẽ được cung cấp một cách an toàn và hiệu quả hơn.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: medicalPatient.thumb,
        data: 'medicalPatient',
        link: '/vi/enterprise/medical/patient',
      },
      {
        img: medicalWaste.thumb,
        data: 'medicalWaste',
        link: '/vi/enterprise/medical/waste',
      },
      {
        img: officeAsset.thumb,
        data: 'officeAsset',
        link: '/vi/enterprise/office/asset',
      },
    ],
  },
};
